import axios from 'axios';
import laroute from '@/shared/laroute';

export const getConceptTop = (hallId) => {
    const getConceptTopUrl = laroute.route('user.api.hall.concept.index', {
        hall: hallId,
    }) + '/';
    return axios.get(getConceptTopUrl);
};

export const getConceptStaff = (hallId) => {
    const getConceptStaffUrl = laroute.route('user.api.hall.concept.staff', {
        hall: hallId,
    }) + '/';
    return axios.get(getConceptStaffUrl);
};

export const getConceptPortfolio = (hallId) => {
    const getConceptPortfolioUrl = laroute.route('user.api.hall.concept.portfolio', {
        hall: hallId,
    }) + '/';
    return axios.get(getConceptPortfolioUrl);
};
